import { styled } from '@mui/material';
import {
  ElementType,
  ForwardRefExoticComponent,
  ReactNode,
  RefAttributes,
} from 'react';
import { NavLinkProps } from 'react-router';

import { useMenuContext } from '../hooks/useMenuContext';
import { MenuItem } from '../../MenuItem';

export type ContextMenuItemProps = {
  children: ReactNode;
  href?: string;
  onClick?: () => void;
  variant?: 'danger';
  className?: string;
  component?:
    | ElementType
    | ForwardRefExoticComponent<
        NavLinkProps & RefAttributes<HTMLAnchorElement>
      >;
};

const StyledMenuItem = styled(MenuItem)<{ variant?: 'danger' }>(
  ({ theme, variant }) => ({
    borderRadius: theme.spacing(3),
    minHeight: 50,
    width: '100%',
    padding: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    '&:link,&:visited,&:hover,&:active': {
      color:
        variant === 'danger'
          ? 'var(--error-error-color)'
          : 'var(--text-text-primary-color)',
    },
    svg: {
      fill:
        variant === 'danger'
          ? 'var(--error-error-color)'
          : 'var(--text-text-primary-color)',
    },
  })
);

export const ContextMenuItem = ({
  onClick,
  children,
  href,
  component,
  variant,
  className,
}: ContextMenuItemProps) => {
  const { closeMenu } = useMenuContext();

  const handleClick = () => {
    if (onClick) onClick();
    closeMenu();
  };

  return (
    <li>
      <StyledMenuItem
        className={className}
        variant={variant}
        onClick={handleClick}
        component={component}
        to={href || ''}
      >
        {children}
      </StyledMenuItem>
    </li>
  );
};
